import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, limit, startAfter, updateDoc, orderBy, collection, Timestamp, documentId } from "firebase/firestore";
import { db } from "../../firebase";
import { Randomcode } from '../../components/rendom_code';
import { Helmet } from "react-helmet";
import Loading from '../../components/loading';
import Cookies from 'js-cookie';
import { Buffer } from 'buffer';
import { useToast } from '../../components/ToastContext';
import Statusbar from '../../master_root/statusbar';
import { MdSearch, MdAdd, MdSettings, MdOutlineChecklist, MdDisplaySettings, MdMoreHoriz, MdStar, MdOutlineAddTask, MdAddToQueue, MdEdit, MdSave, MdSaveAs, MdListAlt, MdLight } from 'react-icons/md';
import { CgLockUnlock, CgLock } from "react-icons/cg";
import Loadingimg from "../../components/loadingimg";
import '../workstation.css';
import { VscAdd, VscClose } from 'react-icons/vsc';
import { UpdateItemStatusqry } from './update_item_status_ws';
import './update_item_status_ui.css';
import './update_item_status.css';
import { FormatStorageSize } from '../../components/storage_size';
export default function UpdateItemStatus({ data = {} }) {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [itemname, setItemname] = useState('');
  const [description, setdescription] = useState('');
  const [taskdata, setTaskdata] = useState([]);
  const [selectedColor, setSelectedColor] = useState("#3B82F6");
  const [itemuid, setItemuid] = useState("");
  const [groupname, setGroupname] = useState("");
  const [itemstatusdata, setItemstatusdata] = useState("");
  const [locked, setLocked] = useState(false);
  const [puid, setpuid] = useState([]);
  const [taskuid, settaskuid] = useState([]);
  const [statuscomplete, setStatuscomplete] = useState(0);
  const [laststatuscomplete, setLatstatuscomplete] = useState(0);
  const [adminguid, setadminguid] = useState(Cookies.get("adminguid"));
  const [duedate, setDuedate] = useState(Timestamp.now().toDate());
  const [updatedescription, setUpdatedescription] = useState('');
  const [tabselected, settabselected] = useState("Update");
  const [itemstatus, setitemstatus] = useState("Not accepted");
  const [itemstatuscolor, setitemstatuscolor] = useState("#555");
  const [content, setContent] = useState('');
  const editorRef = useRef();
  const ITEMS_PER_PAGE = 10; // min 50, can go up to 1000
  let lastVisible = null;    // to track last document

  const handleInput = () => {
    const el = editorRef.current;
    if (el) {
      el.style.height = 'auto'; // reset height
      el.style.height = `${el.scrollHeight}px`; // set to scroll height

    }
    setContent(editorRef.current.innerText);
  };
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back
    } else {
      navigate('/'); // No history, go to home
    }
  };
  useEffect(() => {
    setadminguid(Cookies.get("adminguid"));
    setGroupname(data?.groupname || "");
    setpuid(data?.puid || "");
    setItemuid(data?.taskuid || "");
    setLatstatuscomplete(data?.status_complete || 0);
    setStatuscomplete(data?.status_complete || 0);
    setItemuid(data?.itemuid || "");
    setSelectedColor(data?.color || "#3B82F6");
    setItemname(data?.itemname || "");
    setdescription(data?.description || "");
    setDuedate(data?.due_date_time?.toDate?.() || null);
    setLocked(data?.locked);
    setitemstatus(data.itemstatus);
    
    setitemstatuscolor(data.itemstatuscolor);
    if (tabselected === 'Status') {
      fetch_itemstatusdata();
    }
  if (itemstatus === "Not accepted") {
       const yellow = getComputedStyle(document.documentElement).getPropertyValue('--yellow').trim();
                    setitemstatuscolor(yellow);
    setitemstatus("Working");
  }
  }, [data]);
  const fetch_itemstatusdata2 = async () => {
    setIsLoading(true);
    try {
      const statusQuery = query(
        collection(db, "projectstaskitemstatus"),
        where("puid", "==", data.puid),
        where("itemuid", "==", data.itemuid),
        where("adminguid", "==", adminguid),
        orderBy("indexstage", "desc")
      );
      const statusSnapshot = await getDocs(statusQuery);
      const dataList = await Promise.all(
        statusSnapshot.docs.map(async (doc) => {
          const statusData = { id: doc.id, ...doc.data() };
          let userData = null;
          if (statusData.guid) {
            const detailsQuery = query(
              collection(db, "users"),
              where("guid", "==", statusData.guid)
            );
            const detailsSnapshot = await getDocs(detailsQuery);
            userData = detailsSnapshot.docs[0]
              ? { uid: detailsSnapshot.docs[0].id, ...detailsSnapshot.docs[0].data() }
              : null;
          }
          return {
            ...statusData,
            userData
          };
        })
      );
      setItemstatusdata(dataList);
    } catch (error) {
      console.error("Error fetching item status:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetch_itemstatusdata = async (isNextPage = false) => {
    setIsLoading(true);
    try {
      let statusQuery = query(
        collection(db, "projectstaskitemstatus"),
        where("puid", "==", data.puid),
        where("itemuid", "==", data.itemuid),
        where("adminguid", "==", adminguid),
        orderBy("indexstage", "desc"),
        limit(ITEMS_PER_PAGE)
      );

      if (isNextPage && lastVisible) {
        statusQuery = query(
          collection(db, "projectstaskitemstatus"),
          where("puid", "==", data.puid),
          where("itemuid", "==", data.itemuid),
          where("adminguid", "==", adminguid),
          orderBy("indexstage", "desc"),
          startAfter(lastVisible),
          limit(ITEMS_PER_PAGE)
        );
      }

      const statusSnapshot = await getDocs(statusQuery);

      // Track the last visible document for pagination
      lastVisible = statusSnapshot.docs[statusSnapshot.docs.length - 1];

      const dataList = await Promise.all(
        statusSnapshot.docs.map(async (doc) => {
          const statusData = { id: doc.id, ...doc.data() };
          let userData = null;
          if (statusData.guid) {
            const detailsQuery = query(
              collection(db, "users"),
              where("guid", "==", statusData.guid)
            );
            const detailsSnapshot = await getDocs(detailsQuery);
            userData = detailsSnapshot.docs[0]
              ? { uid: detailsSnapshot.docs[0].id, ...detailsSnapshot.docs[0].data() }
              : null;
          }
          return {
            ...statusData,
            userData
          };
        })
      );

      setItemstatusdata((prev) =>
        isNextPage ? [...prev, ...dataList] : dataList
      );
    } catch (error) {
      console.error("Error fetching item status:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetch_itemstatusdata();
  }, [data]);
  //updateitem_status 
  const updateitem_status = async () => {
    showToast("Saving...");

    if (data.locked === true) {
      showToast("This item is currently locked.");
      return;
    }
    if (content.replace(/\s/g, '').length >= 1000) {
      showToast("The text length is over 1000 characters.");
      return;
    }
    if (laststatuscomplete > statuscomplete) {
      showToast("Please update required status fields.");
      return;
    }

    if (!itemuid.trim() || !updatedescription.trim()) {
      showToast("Please fill in all required fields.");
      return;
    }
  
    
    const status_complete = parseInt(statuscomplete) || 0;
    const word_count = updatedescription.trim().split(/\s+/).filter(Boolean).length;
    const character_count = updatedescription.replace(/\s/g, '').length;
    const storage = new Blob([updatedescription]).size;
    setLoading(true);
    try {
      const uid = Randomcode(21);
      const result = await UpdateItemStatusqry({
        uid,
        itemuid,
        puid,
        itemstatus,
        itemstatuscolor,
        description: updatedescription,
        word_count,
        character_count,
        storage,
        status_complete,
        due_date_time: Timestamp.fromDate(duedate),
        color: selectedColor,
      });

      if (result.success) {

        setLatstatuscomplete(statuscomplete);
        showToast("Update successful.");
        setTimeout(() => handleGoBack(), 2000);
      } else {
        showToast("Failed to edit item: " + (result.error || "Unknown error"));
      }
    } catch (ex) {
      console.error("An error occurred:", ex);
      alert("An unexpected error occurred: " + ex.message);
    } finally {
      setLoading(false);
    }
  };

  //editor_status
  const editor_status = async () => {
    showToast("Saveing..");
    if (data.locked == true) {
      showToast("This item is currently locked");
      return;
    }
    if (content.replace(/\s/g, '').length >= 500000) {
      showToast("The text length is over 500,000 characters.");
      return;
    }
    if (!itemuid.trim() || !content.trim()) {
      showToast("Please fill in all required fields.");
      return;
    }
    const status_complete = parseInt(laststatuscomplete) || 0;
    setLoading(true);
    try {
      const sizeInBytes = new Blob([content]).size;
      const uid = Randomcode(21);
      const result = await UpdateItemStatusqry({
        uid,
        itemuid,
        itemstatus,
        itemstatuscolor,
        puid,
        description: content,
        word_count: content.trim().split(/\s+/).filter(Boolean).length,
        character_count: content.replace(/\s/g, '').length,
        storage: sizeInBytes,
        status_complete,
        due_date_time: Timestamp.fromDate(duedate),
        color: selectedColor,

      });
      if (result.success) {

        showToast("Update successfully.");

        fetch_itemstatusdata();

      } else {
        showToast("Failed to Edit item: " + (result.error || "Unknown error"));
      }
    } catch (ex) {
      console.error("An error occurred:", ex);
      showToast("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container_roots ">
      <Statusbar data={'Update Status | ' + data.itemname} />

      <Helmet>
        <title>Task Status Update | EditorTask - Manage and Track Your Job Tasks</title>
        <meta name="description" content="Easily update and track the status of your freelance job tasks on EditorTask. Stay organized and keep your projects on schedule." />
        <meta name="keywords" content="task status, job progress, freelance task tracking, project updates, task management, EditorTask, job status update" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Task Status Update | EditorTask - Manage and Track Your Job Tasks" />
        <meta property="og:description" content="Update task status, monitor project progress, and keep your freelance work streamlined on EditorTask." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/tasks/status" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>
      <div className='app_header_height'></div>
      <div className="container_size">
        <div className='tabws-body'>

          <div
            className={`tabsbutton ${tabselected === 'Update' ? 'active' : ''}`}
            onClick={() => settabselected('Update')}
          >
            <a className="tabs-text">Update</a>
            <MdOutlineAddTask className="tabicon" />
          </div>

          <div
            className={`tabsbutton ${tabselected === 'Editor' ? 'active' : ''}`}
            onClick={() => settabselected('Editor')}
          >
            <a className="tabs-text">Editor</a>
            <MdEdit className="tabicon" />
          </div>
          <div
            className={`tabsbutton ${tabselected === 'Status' ? 'active' : ''}`}
            onClick={() => settabselected('Status')}
          >
            <a className="tabs-text">Status</a>
            <MdOutlineChecklist className="tabicon" />
          </div>

        </div>
        {tabselected === 'Update' && (
          <div>
            <div className='close-note-input'>
              <table className='table-style' style={{ borderLeft: `solid 4px ${selectedColor}` }} >
                <tbody>
                  <tr>
                    <td>
                      <div
                        className='projects-input-box'><b>{groupname}</b></div>
                    </td>
                  </tr>
                  <tr>

                    <td>
                      <div
                        className='items-texts'><b>{itemname}</b></div>
                    </td>
                  </tr>
                  <tr>
                    <div className='editor-table-style'>
                      <table >
                        <tr>
                          <td width='40px' >Start</td>
                          <td >
                            {data?.date_time?.toDate?.()?.toISOString?.().split("T")[0]}
                          </td>
                          <td width='40px'><div >Due</div></td>
                          <td width='130px' >
                            <b>{data?.due_date_time?.toDate?.()?.toISOString?.().split("T")[0]}</b>
                          </td>
                        </tr>
                        <tr>
                          <td width='60px' >Update </td>
                          <td >
                            {data?.update_date_time?.toDate?.()?.toLocaleString?.()}
                          </td>
                          <td width='40px'>Last</td>
                          <td width='40px'><b>{laststatuscomplete}</b>%</td>
                        </tr>
                      </table>
                    </div>
                  </tr>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td  >
                            <input onChange={(e) => setStatuscomplete(e.target.value)} step={1} value={statuscomplete} type="range" class="modern-range" id="myRange" min="0" max="100"  ></input>  </td>
                          <td width='30px'><span className='modern-range-lable'>{statuscomplete}%</span></td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td >
                      <textarea id='updatedescription_textarea' maxLength={1000} className='projects-input-box' value={updatedescription} onChange={(e) => setUpdatedescription(e.target.value)} placeholder='Enter About status' rows={4}></textarea>

                    </td>
                  </tr>
                  <tr>
                    <td >
                      <div className="status-div" style={{ margin: '2px 2px 10px 2px' }}>
                        {itemstatus === "Not accepted" ? ( 
                          <div className="not-started">Accepted</div>
                        ) : (
                          <>
                            <div

                              onClick={() => {
                                setitemstatus("Stop");
                                const primary = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
                                setitemstatuscolor(primary);
                              }}
                              className={`started ${itemstatus === "Stop" ? "stop" : ""}`}>
                              Stop
                            </div>
                            <div onClick={() => {
                              setitemstatus("Working");
                              const yellow = getComputedStyle(document.documentElement).getPropertyValue('--yellow').trim();
                              setitemstatuscolor(yellow);

                            }} className={`started ${itemstatus === "Working" ? "done_yellow" : ""}`}>
                              Working
                            </div>
                            <div onClick={() => {
                              setitemstatus("Stuck");
                              const red = getComputedStyle(document.documentElement).getPropertyValue('--red').trim();
                              setitemstatuscolor(red);
                            }} className={`started ${itemstatus === "Stuck" ? "done_red" : ""}`}>
                              Stuck
                            </div>
                            <div onClick={() => {
                              setitemstatus("Done");
                              const green = getComputedStyle(document.documentElement).getPropertyValue('--green').trim();
                              setitemstatuscolor(green);
                            }} className={`started ${itemstatus === "Done" ? "done_green" : ""}`}>
                              Done
                            </div>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td >
                      {data.locked === true ? (

                        <div className='action-btn'>
                          <b className="modern-range-label">Locked</b>
                          <div className="button-ui3" onClick={handleGoBack} style={{ marginLeft: `20px` }}  >
                            <VscClose className="icon" /> {loading ? "Close..." : "Close"}
                          </div>
                        </div>

                      ) : (

                        <div className='action-btn'>
                          <div className="button-ui" onClick={updateitem_status}  >
                            <VscAdd className="icon" /> {loading ? "Saving.." : "Save"}
                          </div>

                          <td width="80%"></td>

                          <div className="button-ui3" onClick={handleGoBack} style={{ marginLeft: `20px` }} >
                            <VscClose className="icon" /> {loading ? "Close..." : "Close"}
                          </div>
                        </div>

                      )}

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

         
          </div>
        )}
        {tabselected === 'Editor' && (
          <div className='editor-paid'>
            <table className='table-style' style={{ borderLeft: `solid 4px ${selectedColor}` }} >
              <tbody>
                <tr>

                  <td>
                    <div
                      className='projects-input-box'><b>{groupname}</b></div>
                  </td>
                </tr>
                <tr>

                  <td>
                    <div
                      className='items-texts'><b>{itemname}</b></div>
                  </td>
                </tr>
                <tr>

                  <table className='editor-table-style'>
                    <tr>
                      <td width='40px' >Start</td>
                      <td >

                        {data?.date_time?.toDate?.()?.toISOString?.().split("T")[0]}
                      </td>
                      <td width='40px'><div >Due</div></td>
                      <td width='130px' >
                        <b>{data?.due_date_time?.toDate?.()?.toISOString?.().split("T")[0]}</b>
                      </td>

                    </tr>
                    <tr>
                      <td width='60px' >Update </td>
                      <td >

                        {data?.update_date_time?.toDate?.()?.toLocaleString?.()}
                      </td>
                      <td width='40px'>Last</td>
                      <td width='40px'><b>{laststatuscomplete}</b>%</td>
                    </tr>
                  </table>
                </tr>
              </tbody>
            </table>
            {/* <textarea className='editor-paid-input' value={updatedescription} onChange={(e) => setUpdatedescription(e.target.value)} placeholder='Enter About status' rows={5}></textarea> */}
            <div className="node-paid-editor">
              <div className="text-notepad-container">
                <div className="notepad-toolbar">
                  <button onClick={() => document.execCommand('bold')}><b>B</b></button>
                  <button onClick={() => document.execCommand('italic')}><i>I</i></button>
                  <button onClick={() => document.execCommand('underline')}><u>U</u></button>
                  <select onChange={(e) => document.execCommand('fontSize', false, e.target.value)}>
                    <option value="3">Font Size</option>
                    <option value="2">Small</option>
                    <option value="3">Normal</option>
                    <option value="5">Large</option>
                    <option value="6">X-Large</option>
                  </select>
                  <div className='button-ui3' onClick={editor_status}><MdSave className='icon' />Save</div>
                </div>

                <div
                  ref={editorRef}
                  className="notepad-editor"
                  contentEditable
                  onInput={handleInput}
                  placeholder="Start typing your notes here..."
                ></div>

                <div className="notepad-footer">
                  Word Count: {content.trim().split(/\s+/).filter(Boolean).length} |
                  Character Count: {content.replace(/\s/g, '').length}
                </div>
              </div>

            </div>

          </div>
        )}


        {tabselected === 'Status' && (
          <> <br />
            <div className="update-grid">
              {isLoading ? (
                <Loading />
              ) : itemstatusdata.length === 0 ? (
                <p>No updates available.</p>
              ) : (
                <>

                  {itemstatusdata.map((status, index) => (
                    <div key={status.id || index} className="update-items">
                      <div className='update-div'>
                        <div className='photo-ui-div '>
                          {status.userData.photoURL ? (
                            <img src={status.userData.photoURL} className='photo-ui-img' />
                          ) : (
                            <Loadingimg />
                          )}
                          <div className='name-div'>
                            <table>
                              <tr><td>
                                <div onClick={() => navigate(`/${status.userData.slug}`)} className='name-text'>{status.userData.name.substring(0, 30)}</div>
                              </td>
                                <td  ><div className='status-ui' style={{ backgroundColor: status.itemstatuscolor }}>{status.itemstatus}</div></td>
                              </tr>
                              <tr>
                                <td>
                                  <div className='subscriber-btn'>{status.userData.subscriber} Subscriber
                                  </div></td>

                                <td width='130px'>  <span>{status?.date_time?.toDate?.()?.toLocaleString?.()}</span></td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className='status-description-text'>
                        {status.description} </div>
                      <div className='status-info-div'>
                        <table className='status-table-div'>
                          <tr >
                            <td>#{status.indexstage}</td>
                            <td>Work: <b>{status.status_complete}%</b></td>
                            <td>word: <b>{status.word_count}</b></td>
                            <td>Char: <b>{status.character_count}</b></td>
                            <td width='80px'>Size: <b>{FormatStorageSize(status.storage)}</b></td>

                          </tr>
                        </table>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
            <br />
            <div className='more_button'>

              <div className='button-ui3 btnm' onClick={() => fetch_itemstatusdata(true)}>Load More Status {ITEMS_PER_PAGE}</div>
            </div>
          </>
        )}
  <div className='status-description-text'>
            <b>Description:</b><br/>
            {data.description}</div>
      </div>
      
    </div>
  );

}